import { render, staticRenderFns } from "./CampaignsAccess.vue?vue&type=template&id=279b352a&scoped=true&"
import script from "./CampaignsAccess.vue?vue&type=script&lang=js&"
export * from "./CampaignsAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b352a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279b352a')) {
      api.createRecord('279b352a', component.options)
    } else {
      api.reload('279b352a', component.options)
    }
    module.hot.accept("./CampaignsAccess.vue?vue&type=template&id=279b352a&scoped=true&", function () {
      api.rerender('279b352a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-access/CampaignsAccess.vue"
export default component.exports